import React from "react";
import styles from "./bottom-cta-mobile.module.scss";
import { useTranslation } from "react-i18next";
import { FixButton } from "@/elements-react/fix-button";
import { BottomCtaProps } from "./index";
import {Url} from "@/helpers/url.ts";

export const BottomCtaMobile: React.FC<BottomCtaProps> = ({ onButtonClick }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>
                {t("Ready to work more comfortably?")}
            </h2>
            <p className={styles.subtitle}>
                {t("Register for B2B access and manage your auto parts orders with confidence")}
            </p>

            <FixButton
                variant="primary"
                onClick={onButtonClick}
                className={styles.button}
                labelClassName={styles.btnLabel}
                href={Url.to("signup-page")}
            >
                {t("Become a business customer")}
            </FixButton>
        </div>
    );
};
